export interface GalleryPhoto {
  id: string;
  title: string;
  imageUrl: string;
  category: string;
}

export interface GalleryVideo {
  id: string;
  title: string;
  thumbnailUrl: string;
  videoUrl: string;
  externalUrl?: string;
  duration: string;
}

export const mockPhotos: GalleryPhoto[] = [
  {
    id: 'p1',
    title: 'On Stage - IE',
    imageUrl: 'https://storage.readdy-site.link/project_files/9eec93be-30e4-4db4-94c1-4bae9d306ad9/463fd1e4-b135-4b85-9ac1-1a9f47cac90c_Dirty-Performing.jpeg?v=c7139422b535a751b2b898c6bcb798d5',
    category: 'Performance',
  },
  {
    id: 'p2',
    title: 'Studio Session',
    imageUrl: 'https://static.readdy.ai/image/7064b84365a85e7f169350013ebfe335/b04ef03e48546177046669b31f9b844d.jpeg',
    category: 'Studio',
  },
  {
    id: 'p3',
    title: 'Street Shoot',
    imageUrl: 'https://static.readdy.ai/image/7064b84365a85e7f169350013ebfe335/c91711878fca57da4a75cc58c187d1fb.jpeg',
    category: 'Photoshoot',
  },
  {
    id: 'p4',
    title: 'Festival Headliner',
    imageUrl: 'https://static.readdy.ai/image/7064b84365a85e7f169350013ebfe335/da6e82d0b06b09ae6d6dc868706997ef.jpeg',
    category: 'Performance',
  },
  {
    id: 'p5',
    title: 'Behind The Scenes',
    imageUrl: 'https://static.readdy.ai/image/7064b84365a85e7f169350013ebfe335/070ebc652a02117e3942509f5b16b6b4.jpeg',
    category: 'BTS',
  },
  {
    id: 'p6',
    title: 'IE Roots',
    imageUrl: 'https://static.readdy.ai/image/7064b84365a85e7f169350013ebfe335/b866861befe1b4513e2916b93ff7ecf8.jpeg',
    category: 'Lifestyle',
  },
  {
    id: 'p7',
    title: 'Mic Check',
    imageUrl: 'https://static.readdy.ai/image/7064b84365a85e7f169350013ebfe335/620d1de1eed756a01146d99d7d68106a.jpeg',
    category: 'Performance',
  },
  {
    id: 'p8',
    title: 'Cypher Session',
    imageUrl: 'https://static.readdy.ai/image/7064b84365a85e7f169350013ebfe335/8ccdb95f480ff7fcce98c2dbd2020a59.jpeg',
    category: 'BTS',
  },
  {
    id: 'p9',
    title: 'Press Shot 2024',
    imageUrl: 'https://static.readdy.ai/image/7064b84365a85e7f169350013ebfe335/e78329bf399ea347220c4d1a3888c714.jpeg',
    category: 'Photoshoot',
  },
];

export const mockVideos: GalleryVideo[] = [
  {
    id: 'v1',
    title: 'Somebody Told Me - Official Music Video',
    thumbnailUrl: 'https://static.readdy.ai/image/7064b84365a85e7f169350013ebfe335/25e0f9e0a1a86fd3ddb4d73f4252a038.jpeg',
    videoUrl: 'https://www.youtube.com/embed/i0KOasyWF3Y',
    externalUrl: 'https://youtu.be/i0KOasyWF3Y?si=tHQQBxwiS6KgqNQw',
    duration: '3:42',
  },
  {
    id: 'v2',
    title: 'Dirty- Reel Video',
    thumbnailUrl: 'https://static.readdy.ai/image/7064b84365a85e7f169350013ebfe335/fa4a0da4fc553ed153e5fd4f9d380eb8.jpeg',
    videoUrl: 'https://www.youtube.com/embed/CmpBD-TQJRs',
    externalUrl: 'https://youtu.be/CmpBD-TQJRs?si=vL4lI6rCp50LGen0',
    duration: '4:05',
  },
  {
    id: 'v3',
    title: 'Shoot The Wingz- Video',
    thumbnailUrl: 'https://static.readdy.ai/image/7064b84365a85e7f169350013ebfe335/571dc9885a8d4254c478b393ceec9f3c.jpeg',
    videoUrl: 'https://www.youtube.com/embed/zey20vIosgw',
    externalUrl: 'https://youtu.be/zey20vIosgw?si=KYcGtfOGdPasgbh4',
    duration: '12:30',
  },
];
